<div class="company-logo">
  <img [src]="logoThumbUrl()" alt="company logo" />
</div>
<ng-content></ng-content>
